import { CheckoutAddressTypeEnum } from '@sola/schema/dotcom/checkout/contactInfo.ts';
import type { MailingAddress } from '@sola/schema/dotcom/shared/address.ts';

export const mapAddressDetails = (address: MailingAddress) => ({
  city: address.mailingCity,
  street: address.mailingAddress,
  street2: address.mailingAddress2,
  postalCode: address.mailingPostal,
  country: address.mailingCountry,
  state: address.mailingState,
  type: CheckoutAddressTypeEnum.Mailing,
});
